const SERVICE_URL = "https://www.google.com/s2/favicons";
export function getFavicon(url) {
    return `${SERVICE_URL}?domain=${url}`;
}